import React, { useMemo, useState } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import CommentField from 'redesign/components/molecules/comment-field'
import NewAbsenceRequestAlert from 'redesign/components/organisms/new-absence-request-alert-alert/new-absence-request-alert'
import AbsenceDateSelection from './absence-date-selection'
import AbsencePeriodSelection from './absence-period-selection'
import AbsenceTenantSelection from './absence-tenant-selection'
import { ABSENCE_REQUEST_COMMENT_ID } from './constants'
import { Container } from './styles'
import type { NewAbsenceRequestContentProps } from './types'
import { formatAbsenceDate } from './utils'

const NewAbsenceRequestContent: React.FC<NewAbsenceRequestContentProps> = ({
  formFields,
  formErrors,
  setValue,
  showDialogBlockedPeriod,
  setShowDialogBlockedPeriod,
  selectedPersonTenant,
  firstAvailableDate,
  modulePersonIds,
  handlePersonUuidChange,
  getTenantOptions,
}) => {
  const [displayComment, setDisplayComment] = useState(false)
  const { t, locale } = useFavurTranslation()
  const {
    personUuid: { value: selectedPersonUuid },
    fromDate: { value: fromDate },
    toDate: { value: toDate },
    comment: { value: comment },
    dateRange: { value: dateRange },
  } = formFields

  const startDate = formatAbsenceDate({ date: fromDate, t, locale })
  const endDate = useMemo(() => {
    if (!toDate) return dateRange === 'singleDay' ? startDate : undefined

    return formatAbsenceDate({ date: toDate, t, locale })
  }, [toDate, t, locale, dateRange, startDate])

  return (
    <Container>
      <AbsenceTenantSelection
        formFields={formFields}
        formErrors={formErrors}
        modulePersonIds={modulePersonIds}
        handlePersonUuidChange={handlePersonUuidChange}
        getTenantOptions={getTenantOptions}
      />
      <AbsenceDateSelection
        formFields={formFields}
        setValue={setValue}
        formErrors={formErrors}
        showDialogBlockedPeriod={showDialogBlockedPeriod}
        setShowDialogBlockedPeriod={setShowDialogBlockedPeriod}
        selectedPersonTenant={selectedPersonTenant}
        firstAvailableDate={firstAvailableDate}
      />
      <AbsencePeriodSelection formFields={formFields} setValue={setValue} formErrors={formErrors} />
      <CommentField
        id={ABSENCE_REQUEST_COMMENT_ID}
        value={(comment ?? '') as string}
        onChange={(e) => setValue('comment', e.target.value)}
        displayComment={displayComment}
        setDisplayComment={setDisplayComment}
        commentFieldLabel={t('label.comment')}
        testId="message"
      />
      <NewAbsenceRequestAlert
        startDate={startDate}
        endDate={endDate}
        selectedPersonUuid={selectedPersonUuid as string}
      />
    </Container>
  )
}

export default NewAbsenceRequestContent
